import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import durationPlugin from 'dayjs/plugin/duration';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import useConfig from 'src/hooks/useConfig';
import { parseServerDateTime } from 'src/utils/helpers/transformDate';

import { CELL_RENDER_TYPE } from './constants';

dayjs.extend(durationPlugin);

const CellRender = (props) => {
	const { column, row } = props;
	const type = column.columnDef.renderType;
	const durationUnit = column.columnDef.durationUnit;
	const emptyValue = column.columnDef.emptyValue;
	const val = props.getValue();
	const { i18n } = useConfig();
	const isSubRow = row.depth > 0;

	const emptyNode = isSubRow ? (
		''
	) : (
		<Typography color="secondary">{emptyValue || ''}</Typography>
	);

	if (emptyValue && (val === undefined || val === null)) {
		return emptyNode;
	}

	switch (type) {
		case CELL_RENDER_TYPE.id: {
			return <Typography color="secondary">{val}</Typography>;
		}
		case CELL_RENDER_TYPE.number: {
			if (!val) return emptyNode;
			return <Typography>{val}</Typography>;
		}
		case CELL_RENDER_TYPE.boolean: {
			return (
				<Typography color="secondary">{val ? 'Да' : 'Нет'}</Typography>
			);
		}
		case CELL_RENDER_TYPE.circle: {
			return (
				<Stack direction="row" gap={1} alignItems="top">
					{val.color && (
						<Box
							sx={{
								display: 'block',
								width: 8,
								minWidth: 8,
								height: 8,
								backgroundColor: val.color,
								borderRadius: '50%',
								mt: 0.9,
							}}
						/>
					)}
					<Typography component="span">{val.label}</Typography>
				</Stack>
			);
		}
		case CELL_RENDER_TYPE.date: {
			const parsed = parseServerDateTime(val);
			const date = parsed ? dayjs(parsed).locale(i18n) : null;

			if (!val || !date?.isValid()) return emptyNode;

			return (
				<Typography color="secondary" whiteSpace="nowrap">
					{date.format('DD.MM.YY HH:mm')}
				</Typography>
			);
		}
		case CELL_RENDER_TYPE.duration: {
			if (val == null || val === '') return emptyNode;
			return (
				<Typography whiteSpace="nowrap">
					{durationUnit ? (
						durationUnit(val)
					) : (
						<FormattedMessage
							id="CellRender.duration.days"
							values={{ count: val }}
							defaultMessage="{count, plural, =0 {менее дня} one {# день} two {# дня} few {# дня} many {# дней} other {# дней}}"
						/>
					)}
				</Typography>
			);
		}
		default:
			return <Typography>{val}</Typography>;
	}
};

// Cell API description - https://tanstack.com/table/latest/docs/api/core/cell
CellRender.propTypes = {
	table: PropTypes.any,
	column: PropTypes.any,
	row: PropTypes.any,
	cell: PropTypes.any,
	getValue: PropTypes.func,
	renderValue: PropTypes.func,
};

export default CellRender;
